import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaFilter,
  FaUsers,
  FaCalendarCheck,
  FaClock,
} from "react-icons/fa";
import AppPagination from "../components/AppPagination";
import LeaveModal from "../components/Modals/LeaveModal";
import DeleteModal from "../components/Modals/DeleteModal";

const Leave = () => {
  const [showFilter, setShowFilter] = useState(false);

  const [showLeaveModal, setShowLeaveModal] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [viewMode, setViewMode] = useState(false);

  const [editData, setEditData] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);

  const [loading, setLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, []);
  

  const leaves = [
    {
      id: 1,
      employee: "Amit Sharma",
      leave_type: "Casual Leave",
      from_date: "2026-05-10",
      to_date: "2026-05-12",
      days: 3,
      reason: "Family Function",
      status: "Pending",
    },
    {
      id: 2,
      employee: "Rahul Mittal",
      leave_type: "Sick Leave",
      from_date: "2026-05-15",
      to_date: "2026-05-16",
      days: 2,
      reason: "Fever",
      status: "Approved",
    },
    {
      id: 3,
      employee: "Mahesh Kadel",
      leave_type: "Emergency Leave",
      from_date: "2026-05-18",
      to_date: "2026-05-18",
      days: 1,
      reason: "Personal Work",
      status: "Rejected",
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = leaves.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(leaves.length / itemsPerPage);

  return (
    <div className="lead-page">
      <div className="lead-header">
        <div>
          <h2 className="mb-1">Leave Management</h2>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setViewMode(false);
            setShowLeaveModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Leave
        </button>
      </div>

      <div className="row gx-4 mb-3">
        {/* Total Leave */}
        <div className="col-sm-3 col-12">
          <div className="card my-2 card-info">
            <div className="card-header">
              <h5 className="card-title text-white">Total</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-white">
                  <h2 className="display-6 mb-2 fw-bold">120</h2>

                  <small className="opacity-75">
                    12% higher than last
                  </small>

                  <div className="progress small mt-3">
                    <div
                      className="progress-bar bg-white"
                      role="progressbar"
                      style={{ width: "75%" }}
                    />
                  </div>
                </div>

                <div className="leave-icon-box">
                  <FaUsers size={45} className="text-white opacity-75" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Approved Leave */}
        <div className="col-sm-3 col-12">
          <div className="card my-2 card-success">
            <div className="card-header">
              <h5 className="card-title text-white">Approved</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-white">
                  <h2 className="display-6 mb-2 fw-bold">85</h2>

                  <small className="opacity-75">8% approved this week</small>

                  <div className="progress small mt-3">
                    <div
                      className="progress-bar bg-white"
                      role="progressbar"
                      style={{ width: "65%" }}
                    />
                  </div>
                </div>

                <div className="leave-icon-box">
                  <FaCalendarCheck
                    size={45}
                    className="text-white opacity-75"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pending Leave */}
        <div className="col-sm-3 col-12">
          <div className="card my-2 card-warning">
            <div className="card-header">
              <h5 className="card-title text-white">Pending</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-white">
                  <h2 className="display-6 mb-2 fw-bold">35</h2>

                  <small className="opacity-75">5 pending approvals</small>

                  <div className="progress small mt-3">
                    <div
                      className="progress-bar bg-white"
                      role="progressbar"
                      style={{ width: "45%" }}
                    />
                  </div>
                </div>

                <div className="leave-icon-box">
                  <FaClock size={45} className="text-white opacity-75" />
                </div>
              </div>
            </div>
          </div>
        </div>

         {/* rejected Leave */}
        <div className="col-sm-3 col-12">
          <div className="card my-2 card-danger">
            <div className="card-header">
              <h5 className="card-title text-white">Rejected</h5>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-white">
                  <h2 className="display-6 mb-2 fw-bold">15</h2>

                  <small className="opacity-75">3 rejected leaves</small>

                  <div className="progress small mt-3">
                    <div
                      className="progress-bar bg-white"
                      role="progressbar"
                      style={{ width: "25%" }}
                    />
                  </div>
                </div>

                <div className="leave-icon-box">
                  <FaClock size={45} className="text-white opacity-75" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card */}
      <div className="card card-light">
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <h5 className="card-title mb-0">All Leaves</h5>

          <div className="d-flex align-items-center gap-2">
            {showFilter && (
              <input
                type="text"
                className="form-control"
                placeholder="Search Employee"
              />
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter className="me-1" />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee</th>
                    <th>Leave Type</th>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Days</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>

                        <td className="fw-semibold">{item.employee}</td>

                        <td>{item.leave_type}</td>

                        <td>{item.from_date}</td>

                        <td>{item.to_date}</td>

                        <td>{item.days}</td>

                        <td>
                          <span
                            className={`badge ${
                              item.status === "Approved"
                                ? "bg-success"
                                : item.status === "Rejected"
                                  ? "bg-danger"
                                  : "bg-warning"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex gap-2">
                            {/* View */}
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setEditData(item);
                                setViewMode(true);
                                setShowLeaveModal(true);
                              }}
                            >
                              <FaEye />
                            </button>

                            {/* Edit */}
                            <button
                              className="btn btn-sm btn-info custum_primary"
                              onClick={() => {
                                setEditData(item);
                                setViewMode(false);
                                setShowLeaveModal(true);
                              }}
                            >
                              <FaEdit />
                            </button>

                            {/* Delete */}
                            <button
                              className="btn btn-sm btn-info custum_danger"
                              onClick={() => {
                                setSelectedItem(item);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No Leave Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-3">
            <AppPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={leaves.length}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>

      {/* Leave Modal */}
      <LeaveModal
        show={showLeaveModal}
        setShow={setShowLeaveModal}
        editData={editData}
        viewMode={viewMode}
      />

      {/* Delete Modal */}
      <DeleteModal
        show={showDelete}
        setShow={setShowDelete}
        title="Delete Leave"
        message="Are you sure you want to delete this leave?"
        onConfirm={() => {
          console.log("Delete:", selectedItem);
          setShowDelete(false);
        }}
      />
    </div>
  );
};

export default Leave;
